import {Component} from "@angular/core";
import {Business} from "../../../model/business";
import {BusinessService} from "../../../services/data/business.service";
import {Router} from "@angular/router";
import {CurrentBusinessService} from "../../../services/communication/currentBusinessService";

@Component({
    selector: 'business-form',
    template: require('./business-form.component.html'),
    styles: [
        require('./business-form.component.scss')
    ]
})

export class BusinessFormComponent {
    model = new Business();
    submitted = false;

    constructor(private businessService:BusinessService, private router:Router,
                private currentBusinessService:CurrentBusinessService) {
    }

    newBusiness() {
        this.submitted = true;

        this.businessService.createBusiness(this.model)
            .subscribe(
                business => {
                    this.model = new Business();
                    this.currentBusinessService.changeBusiness(business);
                    this.router.navigateByUrl('/profile');
                },
                error => {
                    console.log(error)
                }
            );

    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/business/form/business-form.component.ts